export function checked(givenValue: any): boolean {
  return Boolean(givenValue);
}
